import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://gtmgusqrrhkuyogttonn.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd0bWd1c3FycmhrdXlvZ3R0b25uIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY2NzQxMTEsImV4cCI6MjA3MjI1MDExMX0.BBZU0oX3VP0UV5_M2Sccng3T0KQicd_934i3oS5YXfo'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Disable email confirmation for easier testing
    flowType: 'pkce'
  }
})

export default supabase